<template>
  <div class="d-flex flex-row align-center">
    <a-group icon="event" class="px-2 py-2">
      <elwrapper label="From" smlabel>
        <v-text-field
          style="width: 140px"
          :value="displayFrom"
          outlined
          hide-details
          dense
          readonly
          @click="showPeriodDialog"
        />
      </elwrapper>
    </a-group>
    <a-group icon="bed" class="px-2 py-2 ml-2">
      <elwrapper label="Nb of nights" smlabel>
        <v-text-field
          style="width: 50px"
          :value="displayNights"
          outlined
          hide-details
          dense
          readonly
          @click="showPeriodDialog"
        />
      </elwrapper>
    </a-group>
    <a-group icon="event" class="px-2 py-2 ml-2">
      <elwrapper label="To" smlabel>
        <v-text-field
          style="width: 140px"
          :value="displayTo"
          outlined
          hide-details
          dense
          readonly
          @click="showPeriodDialog"
        />
      </elwrapper>
    </a-group>
    <PeriodRangeDialog v-model="isDialogShowed" :data="data" @update="updatePeriod" />
  </div>
</template>
<script>
import MONTHS from "@/config/MONTHS";
import PeriodRangeDialog from "./PeriodRangeDialog";
export default {
  props: {
    id: String,
    value: Object,
  },
  data() {
    return {
      isDialogShowed: false,
    };
  },
  components: {
    PeriodRangeDialog,
  },
  computed: {
    data: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.$emit("input", newValue);
      },
    },
    displayFrom() {
      const p = this.value.period || {};
      return this.displayDate(p.startYear, p.startMonth, p.startDay);
    },
    displayTo() {
      const p = this.value.period || {};
      return this.displayDate(p.endYear, p.endMonth, p.endDay);
    },
    displayNights() {
      return this.value.nights;
    },
  },
  methods: {
    showPeriodDialog() {
      this.isDialogShowed = true;
    },
    updatePeriod(data) {
      this.data.period = data.period;
      this.data.nights = data.nights;
      this.$emit("input", this.data);
    },
    displayDate(year, month, day) {
      const parts = [];
      if (year) parts.push(year);
      if (month) parts.push(MONTHS[month - 1].label);
      if (day) parts.push(day);
      return parts.join(" ");
    },
  },
};
</script>
